import { user } from './mapper'
#test
vats =
    at: 1.13,
    ba: 1.17,
    be: 1.21,
    bg: 1.20,
    ch: 1.025,
    cy: 1.05,
    cz: 1.15,
    de: 1.07,
    dk: 1.25,
    ee: 1.20,
    es: 1.21,
    fi: 1.10,
    gb: 1.20,
    gr: 1.24,
    ie: 1.23,
    it: 1.22,
    hr: 1.25,
    hu: 1.27,
    lt: 1.21,
    lv: 1.21,
    mt: 1.18,
    nl: 1.21,
    no: 1.12,
    pl: 1.08,
    pt: 1.23,
    ro: 1.05,
    rs: 1.10,
    se: 1.25,
    sk: 1.20,
    si: 1.10,
    ua: 1.20

export default
    methods:
        $tt: (obj) ->
            locale = this.$root.$i18n.locale
            fallback = this.$root.$i18n.fallbackLocale
            obj[locale] || obj[fallback]

        $currencies: -> ['BAM', 'EUR', 'HUF', 'HRK', 'RON', 'RSD']

        $symbolFor: (currency) ->
            if currency is 'BAM' then return 'KM'
            if currency is 'EUR' then return '€'
            if currency is 'HUF' then return 'Ft'
            if currency is 'HRK' then return 'kn'
            if currency is 'RON' then return 'lei'
            if currency is 'RON' then return 'din'
            
        $languages: ->
            en: 'english'
            hu: 'magyar'

        $countries: -> [
            at:	'Österreich'
        ,
            ba:	'Bosnia I Hercegovína', #, Босна и Херцеговина'
        ,
            be:	'België, Belgique, Belgien'
        ,
            bg: 'България'
        ,
            ch:	'Suisse, Schweiz, Svizzera'#, Svizra'
        ,
            cy: 'Κύπρος - Kıbrıs'
        ,
            cz: 'Česko'
        ,
            de:	'Deutschland'
        ,
            dk:	'Danmark'
        ,
            ee: 'Eesti'
        ,
            es:	'España, Espanya, Espainia'
        ,
            fi:	'Suomi, Finland'
        ,
            gr: 'Ελλάς'
        ,
            gb:	'United Kingdom'
        ,
            hu: 'Magyarország'
        ,
            hr: 'Hrvatska'
        ,
            ie:	'Ireland, Éire'
        ,
            it:	'Italia'
        ,
            lv: 'Latvija'
        ,
            lt: 'Lietuva'
        ,
            mt: 'Malta'
        ,
            nl:	'Nederland, Nederlân'
        ,
            no:	'Norge'
        ,
            pl:	'Polska'
        ,
            pt:	'Portugal'
        ,
            ro: 'România'
        ,
            rs:	'Srbija Србија'
        ,
            se:	'Sverige'
        ,
            sk: 'Slovensko'
        ,
            si: 'Slovenija'
        ,
            ua: 'Ukraїna Україна'
        ]
        $vat: ->
            if user?.details?.address?.country == '' then 1 else 1.27#vats[user?.details?.address?.country] || 1
            